(function () {
  'use strict';

  // helpers
  function isTabClipped(tab) {
    const list = tab.parentElement;
    return (
      tab.offsetLeft < list.scrollLeft ||
      tab.offsetLeft + tab.offsetWidth > list.scrollLeft + list.offsetWidth
    );
  }

  // init
  function initTabSection(section) {
    if (section.dataset.tabsInitialized === 'true') return;
    section.dataset.tabsInitialized = 'true';

    const tabs   = [...section.querySelectorAll('[data-product-tab]')];
    const panels = [...section.querySelectorAll('[data-product-tab-panel]')];

    if (!tabs.length || !panels.length) return;

    // a blockId panel lookup once so activateTab is O(1)
    const panelMap = new Map(
      panels.map(panel => [panel.dataset.blockId, panel])
    );

    // activateTab

    function activateTab(tab, moveFocus) {
      if (!tab) return;

      const blockId = tab.dataset.blockId;

      tabs.forEach(candidate => {
        const active = candidate === tab;
        candidate.classList.toggle('is-active', active);
        candidate.setAttribute('aria-selected', String(active));
        candidate.tabIndex = active ? 0 : -1;
      });

      panels.forEach(panel => {
        const active = panel.dataset.blockId === blockId;
        panel.classList.toggle('is-active', active);
        panel.hidden = !active;
      });

      if (moveFocus) tab.focus({ preventScroll: true });

      // Only scroll when the tab is actually clipped out of view
      if (isTabClipped(tab)) {
        tab.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
      }
    }

    tabs.forEach(tab => {
      tab.addEventListener('click', () => activateTab(tab, false));
    });

    // Keyboard navigation

    tabs.forEach((tab, index) => {
      tab.addEventListener('keydown', event => {
        let targetIndex = index;

        switch (event.key) {
          case 'ArrowRight': targetIndex = (index + 1) % tabs.length;             break;
          case 'ArrowLeft':  targetIndex = (index - 1 + tabs.length) % tabs.length; break;
          case 'Home':       targetIndex = 0;                                      break;
          case 'End':        targetIndex = tabs.length - 1;                        break;
          default:           return;
        }

        event.preventDefault();
        activateTab(tabs[targetIndex], true);
      });
    });

    // Shopify theme editor — block:select sync

    document.addEventListener('shopify:block:select', event => {
      if (!event.target || !section.contains(event.target)) return;

      const blockId = event.detail?.blockId;
      const tab     = tabs.find(t => t.dataset.blockId === blockId);
      activateTab(tab, false);
    });
  }


  function init() {
    document.querySelectorAll('[data-product-tabs]').forEach(initTabSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', event => {
    const section = event.target?.querySelector('[data-product-tabs]');
    if (!section) return;
    // reset guard so initTabSection runs fresh on the new dom
    section.dataset.tabsInitialized = '';
    initTabSection(section);
  });

})();